
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    export class JournalDialog extends _Ext.DialogBase<JournalRow, any> {
        protected getFormKey() { return JournalForm.formKey; }
        protected getIdProperty() { return JournalRow.idProperty; }
        protected getLocalTextPrefix() { return JournalRow.localTextPrefix; }
        protected getNameProperty() { return JournalRow.nameProperty; }
        protected getService() { return JournalService.baseUrl; }
        protected getDeletePermission() { return JournalRow.deletePermission; }
        protected getInsertPermission() { return JournalRow.insertPermission; }
        protected getUpdatePermission() { return JournalRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
        public form = new JournalForm(this.idPrefix);
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initDetailEditor(this, this.form.Details, Config);
            //q.setTextRightAlign(this.form.TdsTotal.element);
            q.hideEditorTab(this.form.Details);

            q.setTextRightAlign(this.form.TotalAmount);


            this.form.CurrencyId.changeSelect2(e => {
                //set Exchange Rate feild of Detail Grid Dialog
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;
                //new JournalDetaildialog().exchangerate = 1;
                Q.Authorization.userDefinition.exchangerate = exchangerate[0].ExchRate;
            });
            (this.form.Details.view as any).onDataChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change
                this.CalculateTotals();

            });


            this.validateForm();
        }
        public CalculateTotals() {
            var amt = 0;
            for (var k of this.form.Details.getItems()) {
                amt += k.Amount;
            }
            this.form.TotalAmount.value = amt;
            if (this.form.Details.getItems().length > 0) {
                q.hideEditorToolbar(this.form.Details);
            }
        }
        protected onDialogOpen() {
            super.onDialogOpen();


            if (this.form.LedgerId.value != "") {
                //set Party Balance Grid in Edit Mode 
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.Details.exchangerate = exchangerate[0].ExchRate;

            }
            else {
                //set Default Values based on Login
                this.form.EnteredBy.value = Q.Authorization.userDefinition.Username;
                Serenity.EditorUtils.setReadOnly(this.form.EnteredBy, true);
                this.form.UserId.value = Q.Authorization.userDefinition.UserId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                //this.form. = exchangerate[0].ExchRate; 
            }
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.Payment',
                getParams: () => ({
                    PaymentID: this.get_entityId()
                })
            }));
            return buttons;
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
            JournalService.Delete(
                {

                    EntityId: this.entityId
                }, response => {
                    Serenity.SubDialogHelper.triggerDataChange(self);
                    self.dialogClose();
                    window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                });
            //} else {
            //    Q.alert("Further Payments for the Vouchers have been made, Cannot delete");
            //    return;
            //}
        }
    }
}
